import { Model as ORMModel, attr } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'


export default class Model extends ORMModel {
  static get fields() {
    return {
      id: attr()
    }
  }
  static reducer(action, Ledger, session) {
    let item
    switch (action.type) {
      default:
        break
      case Types.RESET:
      case Types.RESET_LEDGERS:
        session.Ledger.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.GENERATE_LEDGERS:
        action?.payload?.forEach(newItem => {
          session.Ledger.upsert(newItem)
        })
        break
      case Types.ADD_LEDGER:
        const id = action?.payload?.id || getId()
        Ledger.upsert({ id, ...action.payload })
        break
      case Types.UPDATE_LEDGER:
        item = Ledger.withId(action.payload.id)
        item.update(action.payload)
        break
      case Types.DELETE_LEDGER:
        Ledger.withId(action.payload.id).delete()
        break
    }
  }
}
